import { FunctionComponent, useCallback } from "react"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { useLoginUserPlainMutation } from "../app/services/meseeknaApiV2"
import LogoFull from "../components/logo-full"
import { setRole } from "../features/auth/authSlice"
import LoginFormUserPassword from "../features/auth/components/login-form-user-password"

const LogIn: FunctionComponent = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [loginUserPlain] = useLoginUserPlainMutation()

  // Form fields
  const onForgotPasswordClick = useCallback(() => {
    navigate("/forgot-password")
  }, [navigate])

  const onAuthenticate = useCallback(
    async (params: { email: string; password: string }) => {
      const response = await loginUserPlain({
        username: params.email,
        password: params.password,
      }).unwrap()

      // Set the store role and organization based on the response
      dispatch(
        setRole({
          roleId: response.data?.[0]?.role || -1,
          name: response.data?.[0]?.roleName || "",
        }),
      )

      return response
    },
    [loginUserPlain],
  )

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[100px] px-8 pb-12 box-border items-center justify-start">
      <main className="w-[360px] flex flex-col items-center justify-start gap-[32px] text-left text-sm text-gray-900 font-text-md-regular1">
        <div className="self-stretch flex flex-col items-center justify-start gap-[24px] text-center font-text-md-regular">
          <LogoFull
            dimensions="/v3/assets/meseekna-logo@2x.png"
            logoWrapWidth="189px"
            logoWrapHeight="31.5px"
            image1Width="188.61px"
            image1Height="30.02px"
          />
          <div className="self-stretch flex flex-col items-start justify-start gap-[12px]">
            <h1 className="m-0 self-stretch relative text-2xl leading-[48px] font-semibold font-inherit">
              Log in to your account
            </h1>
            <div className="self-stretch relative text-base leading-[28px] font-text-md-regular1 text-gray-600">
              Welcome back! Please enter your details.
            </div>
          </div>
        </div>
        <div className="self-stretch rounded-xl flex flex-col items-center justify-start gap-[24px] text-gray-700">
          <LoginFormUserPassword onAuthenticate={onAuthenticate} />
        </div>
        <div className="self-stretch flex flex-col items-baseline justify-center gap-[4px] text-primary-700">
          <div className="self-stretch flex overflow-hidden items-center justify-center gap-[8px]">
            <Link onClick={onForgotPasswordClick} to={"/forgot-password"}>
              Forgot Password
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}

export default LogIn
